import React from 'react'
import { Link } from 'react-router-dom'
import { Button } from 'reactstrap'

const BloodGeneral = () => {
  return (
    <div id='website-responsive'>
        <div className='left-padding4rem right-padding4rem px-md- py-md-5 py-4'>
            <div className=''>
                <text className='fs-ss-32-1 text-montserrat text-ss-primary fw-700 lh-1-2'>
                    UNITED LAB CARE GENERAL BLOOD WORK
                </text>
                <hr className='hr-style my-md-2' style={{ width:'80px', marginTop:'2px', marginBottom:'4px'}}/>
            </div>

            <div className='pb-3'>
                <text className='fs-ss-30-2 text-montserrat fw-600 text-ss-black' style={{ fontStyle:'italic'}}>
                    Blood Testing Lab Service in Chicago, IL
                </text>
            </div>

            <div className='pb-2'>
                <text className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                    When it comes to maintaining your health, blood work is a crucial component. If you’re looking for blood work near you or need any blood test in Chicago, United Lab Care offers a comprehensive range of services, including an A1C test, CBC test, CMP test, STI test, HIV test, STD test, and vitamin test. Our convenient locations make accessing reliable and accurate blood testing services easy.  
                </text>
            </div>

            <div className='py-4'>
                <text className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                    Healthcare providers in Chicago commonly order blood tests like A1c, CBC, or CMP tests to assess your health. These tests serve multiple purposes, including evaluating organ function, diagnosing diseases, monitoring medication effectiveness, identifying bleeding or clotting disorders, assessing immune system health, diagnosing anemia, detecting hemoglobin variations, and monitoring chronic conditions. Understanding why a blood test has been ordered is essential, so don’t hesitate to ask your healthcare provider for clarification. 
                </text>
            </div>

            <div className='py-2'>
                <text className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                    Blood work tests are routine medical procedures that can be conducted during physical examinations or in response to specific symptoms. They encompass a wide range of assessments, such as blood cell and platelet evaluations, measurement of electrolytes, proteins, and hormones, and analysis of mineral levels. It’s important to note that while blood tests aid in diagnosing health issues, they provide a snapshot rather than a complete diagnosis. Additional tests, such as HIV tests, may be necessary to understand your condition comprehensively. 
                </text>
            </div>

            <div className='pt-md-4 pt-3 flex-center1 pb-md-0 pb-4'>
            <Link to='/blood-test-lab-in-chicago' >
                <Button className='btn-ss-secondary rounded20 ' style={{  boxShadow:'1px 1px 6px 0 rgba(0,0,0,.4)'}}>
                        <text className='text-montserrat fw-600 fs-ss-18' style={{ padding:'12px 14px',}}>
                            Book Appointment
                        </text>
                </Button>
            </Link>
            </div>
        </div>
    </div>
  )
}

export default BloodGeneral